export enum IncrementalFilterType {
  PRODUCT = 'PRODUCT',
  LOCATION = 'LOCATION'
}
